import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { initializeProviderServiceSettings } from '../../../../../actions/business';
import API from '../../../../../libs/api';
import { objectToCamelCase } from '../../../../../libs/format';
import {
  selectAllProviderServiceSettings,
  selectBusinessId,
  selectBusinessType,
} from '../../../../../selectors';

export default function useProviderServiceSettings({
  camelCase = true, // set to false if data saved is not all in snake_case
} = {}) {
  const dispatch = useDispatch();

  const businessId = useSelector(selectBusinessId);
  const businessType = useSelector(selectBusinessType);

  const providerServiceSettings = useSelector(selectAllProviderServiceSettings);

  const [loading, setLoading] = useState(false);

  async function refreshSettings() {
    setLoading(true);
    try {
      const { data } = await API.getProviderServiceSettings(businessId, businessType);
      dispatch(initializeProviderServiceSettings(data));
    } finally {
      setLoading(false);
    }
  }

  async function updateSetting(settingId, payload) {
    setLoading(true);
    try {
      const { data } = await API.updateProviderServiceSettings(
        businessId,
        businessType,
        settingId,
        payload,
      );
      await refreshSettings();

      return data;
    } finally {
      setLoading(false);
    }
  }

  return {
    providerServiceSettings: camelCase
      ? objectToCamelCase(providerServiceSettings)
      : providerServiceSettings,
    loading,
    refreshSettings,
    updateSetting,
  };
}
